import actions from './actions';

const setAdvertiserName = actions.setAdvertiserName;
const setIsFetching = actions.setIsFetching;
const setIsPaymentSuccessful = actions.setIsPaymentSuccessful;

export default {
  setAdvertiserName,
  setIsFetching,
  setIsPaymentSuccessful,
};
